export const BELogo = ({ className = "", size = 34, variant = "red" }) => {
  // variant: 'red' (on white) or 'white' (on orange header)
  const color = variant === "white" ? "#ffffff" : "#e62323";
  return (
    <div
      className={`inline-flex items-baseline leading-none select-none ${className}`}
      style={{
        fontFamily: "Cabinet Grotesk, sans-serif",
        fontWeight: 900,
        letterSpacing: "-0.06em",
        color,
        fontSize: size,
      }}
      data-testid="be-logo"
    >
      <span>B</span>
      <span style={{ marginLeft: "-0.08em" }}>E</span>
    </div>
  );
};

export const BELogoMark = ({ className = "", variant = "red" }) => {
  const textColor = variant === "white" ? "#fff" : "#111113";
  const subColor = variant === "white" ? "rgba(255,255,255,0.72)" : "#6b6b72";
  return (
    <div
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid="be-logo-mark"
    >
      <BELogo size={28} variant={variant} />
      <div className="hidden sm:flex flex-col leading-tight border-l pl-3" style={{ borderColor: variant === "white" ? "rgba(255,255,255,0.3)" : "#e1e1e6" }}>
        <div
          className="text-[11px] font-bold tracking-[0.18em] uppercase"
          style={{ color: textColor }}
        >
          Bhumi Equipments
        </div>
        <div
          className="text-[9px] tracking-[0.22em] uppercase mt-0.5"
          style={{ color: subColor }}
        >
          Authorised Dealer · Bobcat
        </div>
      </div>
    </div>
  );
};
